var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 25C36.5 18.9242 31.5758 14 25.5 14C19.4242 14 14.5 18.9242 14.5 25C14.5 30.4914 18.5219 35.0418 23.7812 35.8668V28.1797H20.9883V25H23.7812V22.5766C23.7812 19.8201 25.4227 18.2969 27.9363 18.2969C29.1395 18.2969 30.3984 18.5117 30.3984 18.5117V21.2188H29.0105C27.6441 21.2188 27.2188 22.0674 27.2188 22.9375V25H30.2695L29.7818 28.1797H27.2188V35.8668C32.4781 35.0418 36.5 30.4914 36.5 25Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7818 28.1797L30.2695 25H27.2188V22.9375C27.2188 22.0674 27.6441 21.2188 29.0105 21.2188H30.3984V18.5117C30.3984 18.5117 29.1395 18.2969 27.9363 18.2969C25.4227 18.2969 23.7812 19.8201 23.7812 22.5766V25H20.9883V28.1797H23.7812V35.8668C24.342 35.9549 24.9156 36 25.5 36C26.0844 36 26.658 35.9549 27.2188 35.8668V28.1797H29.7818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cede7355444605f79c4a63868ddd4abd.svg";
export { ForwardRef as ReactComponent };